// tslint:disable:no-magic-numbers
export enum Shape {
  TRIANGLE = 3,
  SQUARE,
  PENTAGONE,
  HEXAGONE,
  HEPTAGONE,
  OCTAGONE,
  NONAGONE,
  DECAGONE,
  HANDECAGONE,
  DODECAGONE
}
export const RATIO_TRANSITION_HEIGHT = 0.9;
export const MINIMAL_3PX_DISTANCE = 3;
export const MINIMAL_ALIGN_ANGLE = Math.PI / 8;
export const MAXIMAL_ALIGN_ANGLE = 3 * Math.PI / 8;

export interface ShapeConstants {
  MULTIPLICATOR_X: number;
  MULTIPLICATOR_Y: number;
  TRANSLATION_X: number;
  TRANSLATION_Y: number;
  RATIO_TRANSITION_WIDTH: number;
  FACTOR_TRANSITION: number;
  FACTOR_TRANSLATION_X: number;
  FACTOR_TRANSLATION_Y: number;
  FACTOR_BORDER_X: number;
  FACTOR_BORDER_Y: number;
}

export const CONSTANTS: Map<Shape, ShapeConstants> = new Map ([
  [Shape.TRIANGLE, {
    MULTIPLICATOR_X: 1.15,
    MULTIPLICATOR_Y: 1.32,
    TRANSLATION_X: 1.15,
    TRANSLATION_Y: 0.88,

    RATIO_TRANSITION_WIDTH: 1.15,
    FACTOR_TRANSITION: 1.0,
    FACTOR_TRANSLATION_X: 1.0,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.8,
    FACTOR_BORDER_Y: 2.0
  }],
  [Shape.SQUARE, {
    MULTIPLICATOR_X: 1.0,
    MULTIPLICATOR_Y: 1.0,
    TRANSLATION_X: 1.0,
    TRANSLATION_Y: 1.0,
    RATIO_TRANSITION_WIDTH: 1.0,
    FACTOR_TRANSITION: 1.0,
    FACTOR_TRANSLATION_X: 1.0,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.38,
    FACTOR_BORDER_Y: 1.38,
  }],
  [Shape.PENTAGONE, {
    MULTIPLICATOR_X: 1.05,
    MULTIPLICATOR_Y: 1.1,
    TRANSLATION_X: 1.05,
    TRANSLATION_Y: 0.97,
    RATIO_TRANSITION_WIDTH: 1.04,
    FACTOR_TRANSITION: 1.01,
    FACTOR_TRANSLATION_X: 1.0,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.2,
    FACTOR_BORDER_Y: 1.2,
  }],
  [Shape.HEXAGONE, {
    MULTIPLICATOR_X: 1.1,
    MULTIPLICATOR_Y: 1.0,
    TRANSLATION_X: 0.9,
    TRANSLATION_Y: 1.1,
    RATIO_TRANSITION_WIDTH: 1.1,
    FACTOR_TRANSITION: 0.909,
    FACTOR_TRANSLATION_X: 0.9,
    FACTOR_TRANSLATION_Y: 0.92,
    FACTOR_BORDER_X: 1.0,
    FACTOR_BORDER_Y: 1.0,
  }],
  [Shape.HEPTAGONE, {
    MULTIPLICATOR_X: 1.015,
    MULTIPLICATOR_Y: 1.05,
    TRANSLATION_X: 1.025,
    TRANSLATION_Y: 1.08,
    RATIO_TRANSITION_WIDTH: 1.1,
    FACTOR_TRANSITION: 1.02,
    FACTOR_TRANSLATION_X: 1.0,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.0,
    FACTOR_BORDER_Y: 1.0,
  }],
  [Shape.OCTAGONE, {
    MULTIPLICATOR_X: 1.0,
    MULTIPLICATOR_Y: 1.0,
    TRANSLATION_X: 1.0,
    TRANSLATION_Y: 1.0,
    RATIO_TRANSITION_WIDTH: 1.0,
    FACTOR_TRANSITION: 1.0,
    FACTOR_TRANSLATION_X: 1.0,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.1,
    FACTOR_BORDER_Y: 1.1,
  }],
  [Shape.NONAGONE, {
    MULTIPLICATOR_X: 1.01,
    MULTIPLICATOR_Y: 1.027,
    TRANSLATION_X: 1.0,
    TRANSLATION_Y: 1.0,
    RATIO_TRANSITION_WIDTH: 1.04,
    FACTOR_TRANSITION: 1.0,
    FACTOR_TRANSLATION_X: 1.0,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.05,
    FACTOR_BORDER_Y: 1.05,
  }],
  [Shape.DECAGONE, {
    MULTIPLICATOR_X: 1.0,
    MULTIPLICATOR_Y: 1.0,
    TRANSLATION_X: 1.0,
    TRANSLATION_Y: 1.0,
    RATIO_TRANSITION_WIDTH: 1.06,
    FACTOR_TRANSITION: 1.0,
    FACTOR_TRANSLATION_X: 0.95,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.0,
    FACTOR_BORDER_Y: 1.0,
  }],
  [Shape.HANDECAGONE, {
    MULTIPLICATOR_X: 1.01,
    MULTIPLICATOR_Y: 1.02,
    TRANSLATION_X: 1.02,
    TRANSLATION_Y: 1.0,
    RATIO_TRANSITION_WIDTH: 1.08,
    FACTOR_TRANSITION: 1.0,
    FACTOR_TRANSLATION_X: 1.0,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.3,
    FACTOR_BORDER_Y: 1.03,
  }],
  [Shape.DODECAGONE, {
    MULTIPLICATOR_X: 1.0,
    MULTIPLICATOR_Y: 1.0,
    TRANSLATION_X: 1.0,
    TRANSLATION_Y: 1.0,
    RATIO_TRANSITION_WIDTH: 1.0,
    FACTOR_TRANSITION: 1.0,
    FACTOR_TRANSLATION_X: 1.0,
    FACTOR_TRANSLATION_Y: 1.0,
    FACTOR_BORDER_X: 1.01,
    FACTOR_BORDER_Y: 1.01,
  }],
]);
